import styled from "styled-components";
import { LinkText } from "./linktext.styles";
export const StyledLink = styled.a `
  &&& {
    display: inline-flex;
    position: relative;
    align-items: ${({ inContext }) => (inContext ? "baseline" : "center")};
    ${({ disabled }) => disabled ? "cursor: default; pointer-events: none;" : ""};
    ${({ inContext }) => !inContext
    ? `height: 2.375rem; 
           padding: 0 0.5rem;
          min-width: 3.75rem;`
    : `padding: 0 0.125rem;
           min-width: 2.5rem;
    `};

    color: ${({ stylingType, disabled }) => disabled ? stylingType.disabled.color : stylingType.color};
    background-color: ${({ stylingType }) => stylingType.background};
    border: 1px solid ${({ stylingType }) => stylingType.border};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    ${({ standardFontSize, inheritFontSize, theme }) => {
    if (inheritFontSize)
        return "";
    return standardFontSize
        ? `font-size: ${theme.fontTokens.font12[0]}; line-height: ${theme.fontTokens.font12[1]};`
        : `font-size: ${theme.fontTokens.font11[0]}; line-height: ${theme.fontTokens.font11[1]};`;
}};
    text-decoration: none;
    ${({ alignByContent, inContext }) => {
    const transaltionValue = inContext ? 5 : 9;
    return alignByContent === "left"
        ? `transform: translate(-${transaltionValue}px);`
        : alignByContent === "right"
            ? `transform: translate(${transaltionValue}px);`
            : "";
}}

    > span:first-child {
      ${({ inContext, hasArrow }) => inContext
    ? "padding-right:0.375rem; align-self: center;"
    : hasArrow
        ? "align-self: center; padding-right: 0.5rem;"
        : ""};
      transition:
        padding-right 0.3s ease,
        transform 0.3s ease;
    }

    @media (hover: hover) {
      &:hover > span:first-child {
        ${({ hasArrow, inContext }) => hasArrow
    ? `transform: translateX(3px);`
    : ""};
        }
      }
    }

    @media ${({ theme }) => theme.device.touch} {
      ${({ alignByContent, inContext }) => {
    const transaltionValue = inContext ? 5 : 11;
    if (!transaltionValue)
        return "";
    return alignByContent === "left"
        ? `transform: translate(-${transaltionValue}px);`
        : alignByContent === "right"
            ? `transform: translate(${transaltionValue}px);`
            : "";
}}
    }

    @media (hover: hover) {
      &:hover {
        border: 1px solid transparent;
        ${({ stylingType, disabled }) => !disabled ? `color: ${stylingType.hover.color};` : ""};

        & > ${LinkText} {
          ${({ stylingType, disabled }) => !disabled
    ? `border-bottom: 1px solid ${stylingType.hover.border};`
    : ""};
        }

        svg {
          ${({ stylingType, disabled }) => !disabled ? `fill: ${stylingType.hover.color}` : ""};
        }
      }
    }

    &:focus {
      outline-offset: 0;
      ${({ stylingType, focused }) => focused ? `border: 1px solid ${stylingType.focus.border};` : ""};

      ${({ stylingType, focused }) => focused
    ? `outline: 1px solid ${stylingType.focus.border};`
    : "outline: none;"};
    }

    &:active {
      ${({ theme }) => theme.global.disableTapHighlight}

      ${({ stylingType, disabled }) => !disabled ? `border: 1px solid ${stylingType.active.border};` : ""};
      ${({ stylingType, disabled }) => !disabled ? `color: ${stylingType.active.color};` : ""};

      & > ${LinkText} {
        ${({ stylingType, disabled }) => !disabled
    ? `border-bottom: 1px solid ${stylingType.active.color};`
    : ""};
      }

      svg {
        ${({ stylingType, disabled }) => !disabled ? `fill: ${stylingType.active.color}` : ""};
      }
    }

    svg {
      fill: ${({ stylingType, disabled }) => disabled ? stylingType.disabled.color : stylingType.color};
    }

    ${({ hasArrow, stylingType, disabled }) => !hasArrow &&
    `& > ${LinkText} {
          border-bottom: 1px solid ${disabled ? stylingType.disabled.color : stylingType.color};
        }`};
  }
`;
